import React from "react";

const TextPreview = ({ blockItems }) => {
    const textItems = blockItems.filter((item) => String(item?.text || item?.description || item?.label || "").trim().length > 0);

    return (
        <div className="block-preview-card">
            {textItems.map((item, idx) => (
                <p key={`text-${idx}`}>{item?.text || item?.description || item?.label || ""}</p>
            ))}
        </div>
    );
};

export default TextPreview;
